import { useNavigate } from 'react-router-dom';
import useCreate from '../../useCreate';
import toast from 'react-hot-toast';

const useCreateIngredient = ({ reset }) => {
  const navigate = useNavigate();
  
  const { setDataToServer } = useCreate({
    url: 'ingredients/create',
    refreshUrl: 'ingredients/list',
    onSuccess: () => {
      reset?.();
      toast.success("Ingredient Added Successfully", {
        position: "top-right",
        duration: 3000
      });
      navigate('/catalog/ingredients');
    }
  });
  
  const handleSubmit = (data) => {
    setDataToServer.mutate(data);
  };

  return { handleSubmit };
};

export default useCreateIngredient;
